import { render, staticRenderFns } from "./demandRecord.vue?vue&type=template&id=5976d142&"
import script from "./demandRecord.vue?vue&type=script&lang=js&"
export * from "./demandRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports